import axios from 'axios';
import { hashHistory } from 'react-router';

import url from '../../components/common/BaseURL';

const baseURL = url.baseURL;

export const loginCheck = () => {
    return (dispatch) => {
        dispatch({ type: 'LOGGEDIN_CHECK' });
        const data = localStorage.getItem('data');
            if (data) {
                // promise object retrived from AsyncStorage is of string type.
                // 'JSON.parse' is used to convert it into object
                const user = JSON.parse(data);
                dispatch({ type: 'LOGGEDIN', payload: user });
            } else {
                dispatch({ type: 'NOT_LOGGEDIN' });
                setTimeout(() => {
                }, 1000);
            }
    };
};


export const logout = (user) => {
    return (dispatch) => {
        dispatch({ type: 'LOGOUT' });
        axios.post(baseURL + 'users/logout', {
            token: user.users.token,
            user_id: user.users.user_id
        }).then(response => {
                localStorage.removeItem('data');
                dispatch({ type: 'LOGOUT_SUCCESS' });
                hashHistory.push('/');
        }).catch((err) => {
            localStorage.removeItem('data');
            dispatch({ type: 'LOGOUT_FAILURE' });
            hashHistory.push('/');
            console.log(err, err.response.data);
        });
    };
};



// WEBPACK FOOTER //
// ./src/actions/Auth/UserLoginCheck.js